<template>
  <div class="p-2 space-y-2" aria-hidden="true">
    <div
      v-for="n in count"
      :key="n"
      class="flex gap-3 px-3 py-2.5 rounded-xl bg-slate-50/80 dark:bg-slate-800/40"
    >
      <div
        class="shrink-0 w-10 h-10 rounded-xl bg-slate-200/80 dark:bg-slate-700/60 animate-pulse"
      ></div>
      <div class="flex-1 min-w-0 space-y-2 py-0.5">
        <div
          class="h-3.5 rounded-md bg-slate-200/80 dark:bg-slate-700/60 animate-pulse"
          :class="n === 1 ? 'w-[72%]' : 'w-[58%]'"
        ></div>
        <div
          class="h-3 rounded-md bg-slate-100 dark:bg-slate-800/80 animate-pulse w-[90%]"
        ></div>
        <div
          class="h-2.5 rounded-md bg-slate-100 dark:bg-slate-800/80 animate-pulse w-[28%]"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  count: { type: Number, default: 4 },
});
</script>
